import i18next from "i18next";
import moment from "moment";
import { EDGE_DATE_FORMAT, FREE } from "./Constants";

export const formatDossierCreationData = (
  data,
  documentsSelected
) => {
  if (data.expirationDate) {
    data.expirationDate = moment(data.expirationDate).format(EDGE_DATE_FORMAT);
  }

  if (data.dossierType !== FREE) {
    data.dossierTypeCode = data.dossierType;
  } else {
    data.dossierTypeCode = null;
    data.requiredDocuments = documentsSelected;
  }
  delete data.dossierType;

  return data;
};

export const getDepositorOrTransmitter = (evidence) => {  
  const metadata = evidence.metadata;
  if (evidence.issuer === "ALTARES") {
    return (
      evidence.transmitter && i18next.t(`transmitters.${evidence.transmitter}`)
    );
  }
  if (metadata?.depositor) {
    return metadata?.depositor;
  } else if (evidence?.submitterName) {
    return evidence?.submitterName;
  } else {
    return (
      (evidence.transmitter && i18next.t(`transmitters.${evidence.transmitter}`))
    );
  }
};
